import { render } from "./NotFoundView.vue?vue&type=template&id=74b36f3f&scoped=true"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=74b36f3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b36f3f"]])

export default __exports__